import { type RefObject } from 'react';
import { create } from 'zustand';

export interface TimelineSection {
  id: string;
  title: string;
  ref: RefObject<HTMLElement | null>;
}

interface TimelineState {
  sections: TimelineSection[];

  addSection: (section: TimelineSection) => void;
  removeSection: (id: string) => void;
}

const useTimelineStore = create<TimelineState>()((set) => ({
  sections: [],

  addSection(section) {
    set((state) => ({ sections: [...state.sections, section] }));
  },

  removeSection(id) {
    set((state) => ({
      sections: state.sections.filter((section) => section.id !== id),
    }));
  },
}));

export default useTimelineStore;
